import { FooterUI } from "./FooterUI";
import { StandardProps } from "../componentMap";
import { FooterEvents } from "./FooterEvents";

export const Footer = ({
  runtimeConfig,
  product,
}: Pick<StandardProps, "product" | "runtimeConfig">) => {
  const { esiBasepath } = runtimeConfig;
  const srcUrl = `${esiBasepath}/esi/footer`;

  return (
    <>
      <FooterEvents product={product} />
      <FooterUI srcUrl={srcUrl} />
    </>
  );
};
